import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, FormControl, Form } from 'react-bootstrap';
// import { Stepper, Step, StepLabel, StepContent, Paper, Typography, Button } from '@material-ui/core';
import { makeStyles, Tooltip, StepLabel, TextField, Card, CardContent, Collapse, List, ListItem, ListItemText, ListItemAvatar, ListItemSecondaryAction, IconButton, Button } from '@material-ui/core';
import MuiAvatar from '@material-ui/core/Avatar';

import { BsArrowRightShort, BsArrowLeftShort } from 'react-icons/bs';
import { BsArrowUpShort, BsArrowDownShort, BsCheck } from 'react-icons/bs';
import { IoMdDoneAll } from 'react-icons/io';
import { FiCheck } from 'react-icons/fi';
import Avatar from 'react-avatar';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: 10
  },
}));



const New = (props) => {


  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState();
  const [completed, setCompleted] = React.useState(new Set());
  const [iscompleted, setisCompleted] = React.useState(false);
  const [skipped, setSkipped] = React.useState(new Set());
  // const steps = getSteps();
  const [steps, setSteps] = React.useState([]);

  const {
    data, onSelectCase
  } = props;

  useEffect(() => {
    setActiveStep(0);
  }, [])


  const totalSteps = () => {
    return data.length;
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  //Not currently an option, keeping function as potential to re-add
  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const skippedSteps = () => {
    return skipped.size;
  };

  const completedSteps = () => {
    return completed.size;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
    onSelectCase(data[newActiveStep]);
  };


  const handleBack = () => {
    let newActiveStep = activeStep > 0 ? activeStep - 1 : 0
    setActiveStep(newActiveStep);
    onSelectCase(data[newActiveStep]);
  };

  const handleStep = (stepIndex) => () => {
    setActiveStep(stepIndex);
    onSelectCase(data[stepIndex]);
  };

  const handleComplete = () => {
    const newCompleted = new Set(completed);
    newCompleted.add(activeStep);
    setCompleted(newCompleted);
    console.log(newCompleted, "step completed");
    if (completed.size !== totalSteps() - skippedSteps()) {
      handleNext();
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted(new Set());
    setSkipped(new Set());
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  function isStepComplete(step) {
    return completed.has(step);
  }


  return (
    <div className={classes.root}>
      <Tooltip title="Last Patient" placement="right" aria-label="add">
        <MuiAvatar className="option-avatar">
          <Button disabled={activeStep === 0} className="arrow-button" onClick={handleBack} >
            <BsArrowUpShort />
          </Button>
        </MuiAvatar>
      </ Tooltip>

      <Stepper nonLinear activeStep={activeStep} className="conf-stepper" orientation="vertical">
        {data && data.map((label, index) => {
          const stepProps = {};
          const buttonProps = {};
          if (isStepOptional(label.patient.id)) {
            buttonProps.optional = <Typography variant="caption">Optional</Typography>;
          }
          if (isStepSkipped(label.patient.id)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label.patient.id} {...stepProps}>
              { index === activeStep ?
                <Tooltip title="Mark Patient Complete" aria-label="add" placement="right">
                  <MuiAvatar onClick={handleComplete} className="complete-avatar">
                    {/* <Button variant="contained" className="conference-button" onClick={handleComplete}> */}
                    {completedSteps() === totalSteps() - 1 ? <IoMdDoneAll /> : <FiCheck />}
                    {/* </Button> */}
                  </MuiAvatar>
                </Tooltip> :
                <Tooltip title={label.patient.firstname + ' ' + label.patient.surname} aria-label="add"
                  placement="right" >
                  <Avatar
                    name={isStepComplete(index) ? 'X' : label.patient.firstname + ' ' + label.patient.surname}
                    size="60"
                    onClick={handleStep(index)}
                    completed={isStepComplete(index)}
                    className={isStepComplete(index) ? 'completed-icon-styles' : 'conference-stepper-labels'}
                    {...buttonProps}
                    round={true}
                  />
                </Tooltip>}
            </Step>
          );
        })}
      </Stepper>

      <Tooltip title="Next Patient" placement="right" aria-label="add">
        <MuiAvatar className="option-avatar">
          <Button onClick={handleNext} className="arrow-button"  >
            <BsArrowDownShort />
          </Button>
        </MuiAvatar>
      </ Tooltip>

      <div>
        {allStepsCompleted() ? (
          <div className="text-center">
            <Typography className={classes.instructions}>
              All cases reviewed
            </Typography>
            <Typography className={classes.instructions}>
              You are finished
            </Typography>
            {/* <Button onClick={handleReset}>Reset</Button> */}
          </div>
        ) : (
            <div>
              <div className="stepper-button-row">
                {activeStep !== data.length &&
                  (completed.has(activeStep) && (
                    <Typography variant="caption" className={classes.completed}>
                      Step {activeStep + 1} already completed
                    </Typography>
                  )
                  )}

              </div>
            </div>
          )}
      </div>
    </div>
  )
};


export default New;